import { render, staticRenderFns } from "./PerformanceMarketingFaqSection.vue?vue&type=template&id=36299b40"
import script from "./PerformanceMarketingFaqSection.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingFaqSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports